interface Size {
  width: number;
  height: number;
}

export const resizeCanvas = (canvas: HTMLCanvasElement, size: Size) => {
  const { height, width } = size;

  if (canvas.width !== width || canvas.height !== height) {
    const { devicePixelRatio: ratio = 1 } = window;
    const context = canvas.getContext('2d');
    canvas.width = width;
    canvas.height = height;
    // adjust for retina screens
    if (ratio > 1) {
      context!.scale(ratio / 2, ratio / 2);
    } else {
      context!.scale(ratio, ratio);
    }

    return true;
  }

  return false;
};

export const predraw = (
  context: CanvasRenderingContext2D,
  canvas: HTMLCanvasElement,
  size: Size,
) => {
  context.save();
  resizeCanvas(canvas, size);
  const { width, height } = context.canvas;
  context.clearRect(0, 0, width, height);
};

export const postdraw = () => {};
